import React, { useCallback } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';

import AppShell from '../components/AppShell';
import { AdminProvider, useAdmin } from './AdminContext';
import { adminApi, can, ROLE_LABEL } from './adminApi';
import AdminPasswordPage from './AdminPasswordPage';
import UsersPage from './UsersPage';
import CompaniesPage from './CompaniesPage';
import AuditPage from './AuditPage';
import MaintenancesPage from './MaintenancesPage';
import UserPage from './UserPage';
import CompanyPage from './CompanyPage';
import VehiclePage from './VehiclePage';
import SalePage from './SalePage';
import '../provider/provider.css';
import './admin.css';

function Shell() {
  const { admin } = useAdmin();

  const handleLogout = async () => {
    try {
      await adminApi.logout();
    } finally {
      window.location.href = '/admin/login';
    }
  };

  if (!admin) return <div className='ad-loading' aria-busy='true' />;

  const nav = [
    { to: '/admin/users', label: 'Clientes', icon: 'user' },
    { to: '/admin/companies', label: 'Oficinas', icon: 'store' },
    { to: '/admin/maintenances', label: 'Manutenções', icon: 'history' },
    ...(can(admin, 'super_admin') ? [{ to: '/admin/audit', label: 'Auditoria', icon: 'file' }] : []),
  ];
  const initials = String(admin.name || '?').split(/\s+/).map((part) => part.charAt(0)).slice(0, 2).join('').toUpperCase();

  return (
    <AppShell
      nav={nav}
      homePath='/admin/users'
      homeLabel='Sobre Rodas, painel administrativo'
      profile={{ to: '/admin/users', initials, label: `${admin.name} · ${ROLE_LABEL[admin.role] || admin.role}` }}
      onLogout={handleLogout}
    >
      {admin.mustChangePassword ? (
        <AdminPasswordPage />
      ) : (
        <Switch>
          <Route exact path='/admin/users' component={UsersPage} />
          <Route exact path='/admin/users/:id(\d+)' component={UserPage} />
          <Route exact path='/admin/companies' component={CompaniesPage} />
          <Route exact path='/admin/companies/:cnpj(\d{11,14})' component={CompanyPage} />
          <Route exact path='/admin/maintenances' component={MaintenancesPage} />
          <Route exact path='/admin/maintenances/:plate([A-Za-z0-9]{7})' component={VehiclePage} />
          <Route exact path='/admin/maintenances/:plate([A-Za-z0-9]{7})/:key' component={SalePage} />
          {can(admin, 'super_admin') && <Route path='/admin/audit' component={AuditPage} />}
          <Redirect to='/admin/users' />
        </Switch>
      )}
    </AppShell>
  );
}

// Painel administrativo: a mesma moldura das areas logadas, com sessao propria.
export default function AdminLayout() {
  const history = useHistory();
  const handleMissingSession = useCallback(() => history.replace('/admin/login'), [history]);

  return (
    <AdminProvider onMissingSession={handleMissingSession}>
      <Shell />
    </AdminProvider>
  );
}
